/* eslint-disable no-redeclare */
import type { z } from 'zod';

import { Decimal } from './decimal';

export const FPL = Decimal;

export type FPL = z.infer<typeof FPL>;
